// React
import React, { Component } from 'react'

// Libraries
import { Provider } from 'react-redux'

// Components
import EmbeddableCart from 'store/modules/cart/EmbeddableCart'
import Themed from 'store/v2/react/components/Themed'

// Shared

const store = window.booqableStore

export default class EmbeddableCartContainer extends Component {
  static displayName = 'EmbeddableCartContainer'

  render () {
    return (
      <Provider store={store}>
        <Themed>
          <EmbeddableCart />
        </Themed>
      </Provider>
    )
  }
}
